import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import LegalLayout from './LegalLayout';

const termsOfServiceContent = `
# 利用規約

## 1. 適用

本規約は、Sinkの利用条件を定めるものです。ユーザーは、本規約に同意したうえで本サービスを利用します。

## 2. アカウント

ユーザーは、正確な情報で登録し、自身のアカウントを適切に管理します。アカウントの不正利用が疑われる場合、運営者は利用停止等の措置を行うことがあります。

## 3. サービス内容

本サービスは、Rawメッセージ、Note、Hint、Asset、タグ、リンク等を保存し、AIによる整理・再発見を支援するサービスです。AI出力は参考情報であり、正確性、完全性、有用性を保証するものではありません。

## 4. ユーザー投稿データ

ユーザーは、自身が入力するデータについて必要な権利を有していることを保証します。運営者は、サービス提供、保守、改善、AI処理、サポート対応に必要な範囲でユーザー投稿データを取り扱います。

## 5. 禁止事項

- 法令または公序良俗に反する行為
- 他者の権利、プライバシー、秘密情報を侵害する行為
- 不正アクセス、過度な負荷、リバースエンジニアリング
- AI providerや外部サービスの規約に違反する行為
- 本サービスを用いた違法、有害、危険なコンテンツ生成
- その他、運営者が不適切と判断する行為

## 6. AI機能

AI機能の出力は誤りを含む可能性があります。重要な判断、医療、法律、金融、投資等に関する判断は、ユーザー自身の責任で確認してください。Asset化などの重要な整理は、ユーザーの確認を前提とします。

## 7. 自分のAPIキーの利用 (BYOK)

ユーザーが自身のAPIキーを利用する場合、APIキーの管理、provider利用料、provider規約への遵守はユーザーの責任とします。

## 8. サービスの変更・中断

本サービスは、機能追加、変更、一時停止または終了することがあります。これらによりユーザーに損害が生じた場合でも、運営者の故意または重過失によるものを除き、運営者は責任を負いません。

## 9. 料金、サブスクリプション、クレジット

本サービスでは、月額サブスクリプション（Light / Standard / Deep）および都度購入のクレジットパック（Small / Medium / Large）を、Stripe を決済代行として提供します。各料金は税込価格で購入画面に表示します。詳細な事業者情報・価格・支払方法・解約/返金条件は「特定商取引法に基づく表記」に従います。

月額サブスクリプションは、解約のお手続きがない限り、各更新日に同一料金で自動更新されます。更新日・金額・解約方法は購入確定前に表示します。解約は管理画面（カスタマーポータル）からいつでも可能で、解約後も当該請求期間の終了日まで利用できます。プラン変更は次回更新時に反映されます。

各プランの月次クレジットは更新時に未使用分が失効し、新たに付与されます。クレジットパックは購入から90日で失効します。役務・デジタルコンテンツの性質上、返金は原則としてお受けできません。

なお、note等の外部サービスでの支援/購読に対して、Sink内で利用できるクレジットを別途付与する場合があります。その付与量・有効期間・利用範囲・反映タイミング等は本サービス上または別途案内する条件に従い、外部サービス側の契約条件とは別に扱います。

## 10. 免責

運営者は、本サービスがユーザーの特定目的に適合すること、AI出力が正確であること、障害が発生しないことを保証しません。

## 11. 規約変更

運営者は、必要に応じて本規約を変更できます。重要な変更は適切な方法で通知します。

## 12. 準拠法・管轄

準拠法は日本法とします。

最終更新日: 2026年6月7日
`;

export default function TermsOfService() {
  return (
    <LegalLayout>
      <div className="markdown-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {termsOfServiceContent}
        </ReactMarkdown>
      </div>
    </LegalLayout>
  );
}
